// src/components/ProtectedRoute/Admin/Consoles/Pages/ScientificNamesConsole.jsx
import React from "react";
import ConsolePageFrame from "../Framework/ConsolePageFrame";
import scientificNamesPlugin from "../Plugins/scientificNames.plugin";
import DialogScientificNameEditor from "../../Dialogs/DialogScientificNameEditor";

export default function ScientificNamesConsole() {
  return (
    <ConsolePageFrame
      title="Scientific Name Data"
      plugin={scientificNamesPlugin}
      searchPlaceholder="Search (name / author / fields...)"
      columnsBuilder={({ onEdit }) => scientificNamesPlugin.columns({ onEdit })}
      renderAddDialog={({ onClose }) => (
        <DialogScientificNameEditor open mode="add" onClose={onClose} />
      )}
      renderEditDialog={({ row, onClose }) => (
        <DialogScientificNameEditor open mode="edit" scientificName={row} onClose={onClose} />
      )}
      toastMessages={{ create: "Scientific name created", update: "Scientific name updated" }}
      initialPageSize={100}
      getRowId={(row) => row.id}
    />
  );
}
